import React, { useEffect } from 'react';
import RouteLeavingGuard from '../../../../components/routeLeaving/routeLeaving';

const onUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = (<RouteLeavingGuard when={true}/>);
};

const useWindowUnload = (formDirty: boolean) => {
  useEffect(() => {
    if (formDirty) {
      window.addEventListener('beforeunload', onUnload);
      return () => window.removeEventListener('beforeunload', onUnload);
    }
  });
};

export default useWindowUnload;
